import styled from 'styled-components';
import * as variables from "pubweb-smokey/dist/components/GridSystem/_vars_widths";
import Colors from "pubweb-smokey/dist/colors";

export const ConsumerAffairsLogoStyles = styled.div`
    @media screen and (min-width: ${variables.mobile_width_percentage}px) {
        .consumer-affairs-logo {
            text-align: center;

            img {
                margin: 35px auto 0 auto;
                max-width: 128px;
                width: 25%;
            }
        }
    }

    @media screen and (min-width: 768px) {
        .consumer-affairs-logo {
            margin-left: 12px;
            position: relative;
            top: -245px;
            width: 16%;

            img {
            width: 100%;
            }
        }
    }

    @media screen and (min-width: 1024px) {
        .consumer-affairs-logo {
            top: -260px;
        }
    }

    @media screen and (min-width: 1500px) {
        .consumer-affairs-logo {
            margin-left: 200px;
        }
    }
`;